import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormUtils } from '../../../../../shared/helpers/formUtils';

@Component({
  selector: 'access-weapon',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './access-weapon.component.html',
  styleUrl: './access-weapon.component.css'
})
export class AccessWeaponComponent implements OnInit, OnChanges {

  @Input() parentInterviewData: any;
  @Output() onSaveSection7 = new EventEmitter<any>();

  yesNo = EYesNo;
  accessWeaponForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What can you do to restrict your child's access to weapons or dangerous items? *",
      formControlName: "restrict_access",
    }
  ]

  radioQuestions = [
    {
      id: 'own_guns',
      questionText: 'Do you have a gun or multiple guns in your home? *',
      formControlName: 'own_guns',
      infoFormControlName: 'own_guns_information'
    },
    {
      id: 'firearms_relative',
      questionText: 'Does your child have access to firearms through friends, relatives, or some other source? *',
      formControlName: 'firearms_relative',
      infoFormControlName: 'firearms_relative_information'
    },
    {
      id: 'military_weapons',
      questionText: 'Does your child have access to weapons other than firearms, such as military knives, martial arts weapons, dangerous materials, or some other kind of weapon? *',
      formControlName: 'military_weapons',
      infoFormControlName: 'military_weapons_information'
    },
    {
      id: 'hurt_someone',
      questionText: 'Has your child ever talked about using a weapon or dangerous material to hurt someone? *',
      formControlName: 'hurt_someone',
      infoFormControlName: 'hurt_someone_information'
    },
    {
      id: 'trouble_for_weapon',
      questionText: 'Has your child ever been in trouble for using a weapon, carrying a weapon, or threatening someone with a weapon? *',
      formControlName: 'trouble_for_weapon',
      infoFormControlName: 'trouble_for_weapon_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}
  
  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['parentInterviewData'] && this.parentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.parentInterviewData && this.parentInterviewData[question.formControlName] !== undefined
                           ? this.parentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.parentInterviewData?.[question.infoFormControlName] || '', disabled: this.parentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.parentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.accessWeaponForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.accessWeaponForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.accessWeaponForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }

  saveAccessWeapon(): void {
    if (this.accessWeaponForm.valid) {
      this.onSaveSection7.emit(this.accessWeaponForm.value);
    }
  }


}
